﻿import $ from "jquery";
import ko from "knockout";

import ProductModel from "./ProductModel";

export default class TabModel {
	constructor(tab, options, firstRun) {
		const _ = this;

		_.options = options;

		_.id = tab.id;
		_.sysName = tab.sysName;
		this.categoryName = ko.observable(_.sysName);
		this.categoryName = this.sysName;
		_.class = `ccs-logo-tab-${_.sysName}`;
		_.selector = `#${options.entryPointId} .${_.class}`;

		_.name = tab.name;
		_.fields = tab.fields;

		_.tabProducts = _.mapProducts(tab.products);

		_.page = ko.observable(0);

		_.initPageSize = tab.pageSize;
		_.pageSize = ko.observable(tab.pageSize || 3);

		_.totalPages = ko.pureComputed(() => Math.ceil(_.subcategoryProducts().length / _.pageSize()));

		_.subcategories = tab.subcategories;
		_.subcategory = ko.observable(_.subcategories[0]);
		_.subcategory.subscribe(() => _.page(0));

		_.subcategoryProducts = ko.computed(() => {
			if (_.subcategory().id === -1) {
				return _.tabProducts;
			}

			return $.map(_.tabProducts, (prod) => {
				return prod().info.subcategory === _.subcategory().id ? prod : null;
			});
		});

		this.buttons = ko.observableArray([]);

		for (var i = 1; i <= _.totalPages(); i++) {
			this.buttons.push({"name": i })
		}

		this.currentPage = ko.observable(1);
		this.getPageData = this.getPageData.bind(this);

		_.products = ko.pureComputed(() => {

			const products = _.options.simple
				? _.tabProducts
				: _.subcategoryProducts().slice(_.startIndex(), _.endIndex());

			if (!_.options.parsingPriceJs) {
				return products;
			}

			// Price should be parsed after the hover is shown.
			if (!firstRun || _.options.inline) {
				_.parsePrice(products);
			}

			firstRun = false;

			return products;
		});

		_.startIndex = ko.pureComputed(() => _.page() * _.pageSize());

		_.endIndex = ko.pureComputed(() => Math.min(_.startIndex() + _.pageSize(), _.subcategoryProducts().length));

		_.pageInfo = ko.pureComputed(() => {
			return ccs_util.stringFormat(
				_.options.pageInfoText,
				(_.startIndex() + 1) + "-" + _.endIndex(),
				_.subcategoryProducts().length);
		});

		_.hasNext = ko.pureComputed(() => _.page() + 1 >= _.totalPages());
		_.hasPrev = ko.pureComputed(() => _.page() - 1 < 0);

		_.footnotes = tab.footnotes;
		_.footnotesWidth = ko.pureComputed(() => _.products().length + 1);

		_.updatePageSize();
	}

	showSubcategories() {
		return this.subcategories.length > 1;
	}

	parsePrices() {
		this.parsePrice(this.products());
	}

	parsePrice(products) {
		$.each(products, (i, product) => {
			product().parsePrice();
		});
	}

	nextPage() {
		this.page(this.page() + 1);
		this.currentPage(this.page() + 1);
	}

	prevPage() {
		this.page(this.page() - 1);
		this.currentPage(this.page()+1);
	}

	getPageData(pageno) {
		this.page(pageno - 1);
		this.currentPage(pageno);
	}

	hasValues(property) {
		const products = this.products();

		for (let i = 0; i < products.length; i++) {
			if (products[i]().info[property]) {
				return true;
			}
		}

		return false;
	}

	mapProducts(products) {
		return products.map(product => ko.observable(new ProductModel(product, this.options)));
	}

	updatePageSize() {
		const _ = this;

		if (!_.options.inline) {
			return;
		}

		const $tab = $(_.selector);

		if (!$tab.is(":visible")) {
			setTimeout(() => _.updatePageSize(), 300);
			return;
		}

		const tableWidth = $tab.width();
		const firstColumnWidth = $tab.find("th:first-child").outerWidth();

		const targetWidth = _.options.columnWidth || 125;

		const pageSize =
			Math.max(1,
				Math.min(
					_.initPageSize || _.tabProducts.length,
					Math.floor((tableWidth - firstColumnWidth) / targetWidth))
			);

		if (_.pageSize() !== pageSize) {
			_.page(0);
			_.pageSize(pageSize);
		}
	}
}
